import React from 'react';
import { LuFileText } from "react-icons/lu";

const InterfaceStatsBar = ({ 
  itemCount, 
  itemType = "Interfaces", 
  createdAt, 
  isLoading = false,
  icon = LuFileText,
  iconColor = "purple-400"
}) => {
  const Icon = icon;
  
  const formatDate = (date) => {
    if (!date) return 'Unknown';
    const dateObj = date.toDate ? date.toDate() : new Date(date);
    return dateObj.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  return (
    <div className="w-full pt-4 pb-4 flex justify-between items-center">
      <div className="flex space-x-6">
        <div className="flex items-center space-x-2">
          <Icon className={`w-4 h-4 text-${iconColor}`} />
          <span className="text-sm text-[#ffffff70]">
            {isLoading ? (
              <div className="h-4 w-16 bg-[#ffffff20] rounded animate-pulse"></div>
            ) : (
              `${itemCount} ${itemCount === 1 ? itemType.slice(0, -1) : itemType}`
            )}
          </span>
        </div>
      </div>
      <div className="flex items-center space-x-2 text-sm text-[#ffffff50]">
        <span>Created on {formatDate(createdAt)}</span>
      </div>
    </div>
  );
};

export default InterfaceStatsBar;